import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tip } from '../shared/domain/tip';
import { SessionService } from '../shared/services/session/session.service';
import { TipSelectionComponent } from './tip-selection/tip-selection.component';
import { LoginService } from '../shared/services/login/login.service';
import { LoginRequest } from '../shared/domain/login-request';
import { SettingsService } from '../shared/services/settings/settings.service';

@Component({
    selector: 'vit-game-view',
    templateUrl: './game-view.component.html',
    styleUrls: ['./game-view.component.scss']
})
export class GameViewComponent implements OnInit {

    @ViewChild(TipSelectionComponent) tipSelection;
    showLogin: boolean = false;

    get activeTips(): Tip[] {
        return this.sessionService.tickets.filter(ticket => ticket.rounds > 0);
    }

    constructor(public sessionService: SessionService,
                public router: Router,
                public route: ActivatedRoute,
                public loginService: LoginService,
                public settingsService: SettingsService) {
    }

    async ngOnInit() {
        let restore: string = this.route.snapshot.params['restore'];
        if(restore === 'true') {
            this.sessionService.restoreState();
        }
        let sessionguid: string = this.route.snapshot.params['sessionguid'];
        if (sessionguid) {
            let loginRequest: LoginRequest = new LoginRequest();
            loginRequest.Guid = sessionguid;
            loginRequest.AccountNr = "guid";
            loginRequest.Password = "guid";
            this.loginService.validateLogin(loginRequest).subscribe((response: any) => {
                this.settingsService.handleSettingsResponse(response.json());
                this.loginService.validateUserAccount();
            });
        }
    }

    navigateToBettingIfCountdown() {
        if (!this.sessionService.punter) {
            this.showLogin = true;
            return;
        }
        let countdownValue: Date = this.sessionService.countdown.value.getValue();
        if (countdownValue && (countdownValue.getMinutes() > 0 || countdownValue.getSeconds() > 0)) {
            this.navigateToBetting();
        }
    }

    navigateToBetting() {
        this.router.navigate(['betting']);
    }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/game-view/game-view.component.ts